authRouter.$inject = ["$stateProvider"];export default function authRouter($stateProvider) {
  "ngInject";

  $stateProvider

  /**
                  * AUTH MODULE STATES
                  */.

  state('gplans.auth', {
    views: {
      $default: {
        component: 'pageAuth' } },


    redirectTo: 'gplans.auth.login' }).


  state('gplans.auth.login', {
    url: '/login',
    views: {
      $default: {
        component: 'loginForm' } },


    title: 'Login' }).


  state('gplans.auth.register', {
    url: '/register',
    views: {
      $default: {
        component: 'registerForm' } },


    title: 'Register' }).


  state('gplans.auth.restorePassword', {
    url: '/restore-password',
    views: {
      $default: {
        component: 'resetPasswordForm' } },


    title: 'Reset Password' });



}